{
  "(optional)": "(opcijsko)",
  "(required)": "(obvezno)"
}
